// components/SeoComponent.js

import { Helmet } from "@vuer-ai/react-helmet-async";

const SeoComponent = ({ title, description, keywords, structuredData }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph meta tags for social sharing */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      {/* Twitter Card meta tags */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

// Default props in case some are not provided
SeoComponent.defaultProps = {
  title: "Your Default Website Title",
  description: "Default description of your website",
  keywords: "default, keywords, for, your, website",
};

export default SeoComponent;
